import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ApplicationsService {

	public url: string;

	constructor(protected http: HttpClient) {
        this.url = environment.api + '/applications';
    }

	apply(formData) {
		return this.http.post(this.url, formData);
	}

}
